const isMobile = () => window.matchMedia("not screen and (hover)").matches

export default isMobile
